<template>
  <Teleport to="body">
    <div class="cookie-wrapper">
      <IconCook class="cookie-icon" />
      <div class="cookie-info">
        <span>Мы используем cookies</span>
        <a href="https://vkusno.namtam.ru/docs/cookie" target="_blank">
          Подробнее
        </a>
      </div>
      <IconCross class="cross" @click="onCrossClickHandler" />
    </div>
  </Teleport>
</template>

<script>
import IconCook from "@/components/icons/IconCook.vue";
import IconCross from "@/components/icons/IconCross.vue";
import { setCookie } from "@/assets/js/utils/helpers";

export default {
  name: "CookieModal",
  components: { IconCross, IconCook },
  methods: {
    onCrossClickHandler() {
      this.$store.commit({
        type: "setShowCookie",
        value: false,
      });
      setCookie("isCookieShown", "1", {
        "max-age": 3600 * 24 * 30,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.cookie-wrapper {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147483647;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px 26px 16px 24px;
  border-radius: 16px;
  box-shadow: 0px -2px 60px 0px #00000026;
  background-color: #ffffff;

  font-family: $font-family-primary;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;

  @include mobile {
    bottom: 80px;
    gap: 12px;
    padding: 16px;
    font-size: 16px;
    line-height: 22px;
  }
}

span {
  color: #f0811e;
}

a {
  color: #858585;
  text-decoration: underline;
}

.cross {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.cookie-icon {
  height: 44px;
  width: 44px;
}

.cookie-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 0 0 auto;

  @include mobile {
    width: 224px;
    align-items: stretch;
    flex-direction: column;
    gap: 0;
  }
}
</style>
